export default function generator(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    labelPadding: spacing.small,
    labelLeftPadding: spacing.large,
    labelBottomPadding: spacing.xxSmall,
    labelFontSize: typography.fontSizeSmall,
    labelColor: colors.contrasts.grey4570,
    editButtonWrapperRightMargin: spacing.large
  };
}